"use client";
import CopyLink from "@/app/assets/icons/copy-link";
import Whatsapp from "@/app/assets/icons/whatsapp";
import { useCleverTapEvents } from "@/app/hooks/use-clevertap";
import useMobile from "@/app/hooks/use-mobile";
import { ICM_NAME_FULL } from "@/app/utils/constants";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
// import { initBranch, trackEvent } from "@/app/utils/branchio";
import { useEffect, useRef } from "react";

interface ShareOptionsProps {
    refLink: string;
    handleCopyLink: () => void;
    username?: string;
    isOpen?: boolean;
    onClose?: () => void;
    email?: string;
    userId?: string;
    phone?: string;
}
const ShareOptions: React.FC<ShareOptionsProps> = ({
    refLink,
    isOpen = false,
    onClose,
    username,
    handleCopyLink,
    email,
    userId,
    phone,
}) => {
    const dialogRef = useRef<HTMLDivElement>(null);
    const { isMobile } = useMobile();
    const { cleverTapTrackEvent } = useCleverTapEvents();

    const WaUrl = `https://web.whatsapp.com/send?text=Hi!%0A%0AI think products on ${ICM_NAME_FULL} will be a great addition to your investment portfolio and wanted to invite you to sign up. By investing, you can diversify and earn higher returns.%0A%0AHere’s my invitation link: ${refLink}%0A%0AHappy Investing,%0A${username || "Team " + ICM_NAME_FULL}`;
    const mobileWaUrl = `https://api.whatsapp.com/send?text=Hi!%0A%0AI think products on ${ICM_NAME_FULL} will be a great addition to your investment portfolio and wanted to invite you to sign up. By investing, you can diversify and earn higher returns.%0A%0AHere’s my invitation link: ${refLink}%0A%0AHappy Investing,%0A${username || "Team " + ICM_NAME_FULL}`;

    useEffect(() => {
        if (!isOpen) return;

        const handleClickOutside = (event: MouseEvent) => {
            if (dialogRef.current && !dialogRef.current.contains(event.target as Node)) {
                onClose?.();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen, onClose]);

    const handleOptionClick = (option: string) => {
        switch (option) {
            case "whatsapp":
                handleWhatsappShare();
                break;

            case "copy":
                handleCopyLink();
                break;
        }

        if (!isMobile && onClose) {
            onClose();
        }
    };

    const handleWhatsappShare = () => {
        cleverTapTrackEvent("US_Ref_ShareClick", { email, phone, userId });
        // initBranch()
        //   .then(() => {
        //     trackEvent("US_Ref_ShareClick", email, phone, userId);
        //   })
        //   .catch(error => console.error('Error initializing Branch:', error))

        setAnalyticsEvent(window.location.origin, "US_Ref_ShareClick");
        window.open(isMobile ? mobileWaUrl : WaUrl, "_blank");
    };

    const shareContent = (
        <div className="flex min-h-[126px] w-full items-center justify-around">
            <div
                className="flex h-full w-max cursor-pointer flex-col items-center justify-center gap-4 px-4 py-5"
                onClick={() => handleOptionClick("whatsapp")}
            >
                <div className="flex h-[48px] w-[48px] items-center justify-center rounded-full bg-slate-100">
                    <Whatsapp />
                </div>
                <p>Whatsapp</p>
            </div>
            <div
                className="flex h-full w-max cursor-pointer flex-col items-center justify-center gap-4 px-4 py-5"
                onClick={() => handleOptionClick("copy")}
            >
                <div className="flex h-[48px] w-[48px] items-center justify-center rounded-full bg-slate-100">
                    <CopyLink />
                </div>
                <p>Copy link</p>
            </div>
        </div>
    );

    if (isMobile) {
        return shareContent;
    }

    return isOpen ? (
        <div
            ref={dialogRef}
            className={`absolute right-[4.25rem] top-[-3rem] z-50 flex items-center justify-center`}
        >
            <div className="w-full min-w-[525px] max-w-md rounded-[16px] bg-white p-4 shadow-lg">
                {shareContent}
            </div>
        </div>
    ) : null;
};

export default ShareOptions;
